import { render, staticRenderFns } from "./swiper1.vue?vue&type=template&id=b5d62f3a&scoped=true&"
import script from "./swiper1.vue?vue&type=script&lang=js&"
export * from "./swiper1.vue?vue&type=script&lang=js&"
import style0 from "./swiper1.vue?vue&type=style&index=0&id=b5d62f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d62f3a",
  null
  
)

export default component.exports